import { cn } from '@/utils/utils_client';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { forwardRef, useState } from 'react';

interface UI_PRIMITIVE__dropdown_menu_item_props extends React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Item> {
  inset?: boolean;
  value: string;
  label?: string;
  values_selected?: string[];
  class_name_hovered_selected?: string;
  on_item_selected?: (value: string) => void;
}

export const UI_PRIMITIVE__dropdown_menu_item = forwardRef<React.ElementRef<typeof DropdownMenuPrimitive.Item>, UI_PRIMITIVE__dropdown_menu_item_props>(
  ({ className, inset, value, label = '', class_name_hovered_selected = '', values_selected = [], on_item_selected = () => {}, ...props }, ref) => {
    const [is_hovered, set_is_hovered] = useState(false);

    /*
     * RENDERS
     */

    function render_children() {
      if (props.children) return props.children;

      return label;
    }

    /*
     * HTML
     */

    return (
      <DropdownMenuPrimitive.Item
        onMouseEnter={() => set_is_hovered(true)}
        onMouseLeave={() => set_is_hovered(false)}
        onClick={() => on_item_selected(value)}
        ref={ref}
        className={cn(
          'relative flex cursor-pointer select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors  data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none ',
          inset && 'pl-8',
          className,
          (values_selected.includes(value) || is_hovered) && class_name_hovered_selected,
        )}
        {...props}
      >
        {render_children()}
      </DropdownMenuPrimitive.Item>
    );
  },
);

UI_PRIMITIVE__dropdown_menu_item.displayName = DropdownMenuPrimitive.Item.displayName;
